import MarkdownQuestionParser from './MarkdownQuestionParser'
import RandomId from '../helpers/random_id'
import url_path from '../helpers/url_helper'
const CkeditorHead = require("../images/ckeditor_sample.jpg")
const paragraphTypes = ["select", "textarea", "checkbox", "multi_checkbox", "radio"]

const examHtml = (tokens, idx, options) => {
  const fieldType = tokens[idx].fieldType;
  switch (fieldType) {
    case "checkbox":
    case "multi_checkbox":
      return `<label><input type="checkbox" name="${RandomId()}" value="${escapeHtml(tokens[idx].content)}" /> ${escapeHtml(tokens[idx].content)}</label><br />`
    case "radio":
      return `<label><input type="radio" name="${tokens[idx].name}" value="${escapeHtml(tokens[idx].content)}" /> ${escapeHtml(tokens[idx].content)}</label><br />`
    case "select":
      return `<option value="${escapeHtml(tokens[idx].content)}">${escapeHtml(tokens[idx].content)}</option>`
    case "textarea":
      return `<textarea name="${RandomId()}" id="${RandomId()}" class="custom-ckeditor"></textarea><br />`
    case "textfield":
      return `<input name="${RandomId()}" type="text" class="form-control" style="width:${tokens[idx].length * 50}px" />`
    default:
      return "";
  }
}

const questionEditorHtml = (tokens, idx, options) => {
  const fieldType = tokens[idx].fieldType;
  switch (fieldType) {
    case "checkbox":
    case "multi_checkbox":
      if (fieldType == "multi_checkbox" && !tokens[idx].content) return "";
      return `<label><input type="checkbox" /> ${escapeHtml(tokens[idx].content)}</label><br />`
    case "radio":
      return `<label><input type="radio" name="${tokens[idx].name}" /> ${escapeHtml(tokens[idx].content)}</label><br />`
    case "textfield":
      return `<input type="text" class="form-control" style="width:${tokens[idx].length * 50}px" />`
    case "textarea":
      return `<label style="background-image: url('${url_path(CkeditorHead)}')" class="ckeditor-sample"><textarea class="ckeditor-sample-textarea"></textarea></label>`
    case "select":
      return `<option value="${escapeHtml(tokens[idx].content)}">${escapeHtml(tokens[idx].content)}</option>`
    default:
      return "";
  }
}

function escapeHtml(input: string): string {
  return input.replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#039;");
}

function isParagraphType(type: string) {
  return paragraphTypes.indexOf(type) >= 0;
}

function isInlineType(type: string) {
  return paragraphTypes.indexOf(type) < 0;
}

function replace(state, fieldType: string = null, lastToken = null): MarkdownQuestionParser {
  let token;

  const max = state.posMax;
  const start = state.pos;

  if (state.src.charCodeAt(start) !== 36 /* $ */) { return null; }
  state.pos = start + 1;
  while (state.pos < max) {
    if (state.src.charCodeAt(state.pos) == 10) {
      state.pos += 1;
      break;
    }
    state.pos += 1;
  }
  const lastPos = state.pos;
  let content = state.src.slice(start + 1, state.pos);
  let parser = new MarkdownQuestionParser(content, fieldType);
  if (parser.found()) {
    state.pos = start;
    if (parser.fieldType == "select" && lastToken == null) {
      token = state.push('select_open', 'select', 1);
      token.attrs = [["class", "form-control"], ["name", RandomId()]]
    }

    if (parser.fieldType == "textarea" && fieldType == "textfield") {
      token = lastToken;
    } else if (parser.fieldType == "multi_checkbox" && parser.allotment) {
      token = null;
    } else {
      token = state.push('question', '', 0);
    }

    if (token) {
      token.content = parser.label;
      token.fieldType = parser.fieldType;
      if (parser.fieldType == "radio") {
        if (lastToken) {
          token.name = lastToken.name;
        } else {
          token.name = RandomId();
        }
      } else if (parser.fieldType == "textfield") {
        token.length = parser.data.length;
      }

      parser.data.token = token;
    }

    state.pos = isParagraphType(parser.fieldType) ? lastPos : parser.lastPosition + start + 1;
  } else {
    state.pos = start;
  }

  return parser;
}
const question_replace = (state, fieldType: string) => {
  let found, token,
    max = state.posMax,
    start = state.pos;

  if (state.src.charCodeAt(start) !== 36 || (paragraphTypes.indexOf(fieldType) >= 0 && (start != 0)) || max < 2) { return false; }
  let parser = replace(state, fieldType);
  let last_parser = parser;
  found = parser && parser.found();
  while (paragraphTypes.indexOf(fieldType) >= 0 && parser && parser.found() && state.pos <= max) {
    parser = replace(state, parser.fieldType, parser.data.token);
    last_parser = parser || last_parser;
  }

  if (last_parser && last_parser.fieldType == "select") {
    token = state.push('select_close', 'select', -1);
  }

  if (!found) {
    state.pos = start;
    return false;
  }

  return true;
}

export default function question_plugin(md, options: { fieldType: string, preview: boolean }) {
  if (options.preview) {
    md.renderer.rules.question = questionEditorHtml;
  } else {
    md.renderer.rules.question = examHtml;
  }
  md.inline.ruler.push('question', (state) => question_replace(state, options.fieldType));
}

export function question_client_plugin(md, options: { fieldType: string, preview: boolean }) {
  if (options.preview) {
    // Not show Question
    md.renderer.rules.question = (tokens, idx, options) => { return "" };
  } else {
    md.renderer.rules.question = examHtml;
  }
  md.inline.ruler.push('question', (state) => question_replace(state, options.fieldType));
}

const questionServiceHtml = (tokens, idx, options) => {
  const fieldType = tokens[idx].fieldType;
  switch (fieldType) {
    case "textfield":
      return `<span><input type="text" class="form-control textfield-question" style="width:${tokens[idx].length * 20}px; display: inline" required/></span>`
    default:
      return "";
  }
}

const defaultRender = (tokens, idx, options, env, self) => {
  return self.renderToken(tokens, idx, options);
};

const blankLink = (tokens, idx, options, env, self) => {
  // If you are sure other plugins can't add `target` - drop check below
  var aIndex = tokens[idx].attrIndex('target');

  if (aIndex < 0) {
    tokens[idx].attrPush(['target', '_blank']); // add new attribute
  } else {
    tokens[idx].attrs[aIndex][1] = '_blank';    // replace value of existing attr
  }
  // pass token to default renderer.
  return defaultRender(tokens, idx, options, env, self);
};

export function question_client_service_plugin(md, options: { fieldType: string, preview: boolean }) {
  if (options.preview) {
    // Not show Question
    md.renderer.rules.question = questionServiceHtml;
    md.renderer.rules.link_open = blankLink;
  } else {
    md.renderer.rules.question = examHtml;
  }
  md.inline.ruler.push('question', (state) => question_replace(state, options.fieldType));
}